import fr from 'facet-rest';
import BulkMessageInput from 'Components/UI/BulkMessageInput/BulkMessageInput';
import Autocomplete from 'Components/UI/Autocomplete';

export const BulkCommunicationOverride = fr.metaOverride()
  .override({ readonly: true }, { hidden: true })
  .nameOverride('isDraft', { hidden: true })
  .nameOverride('sendAt', { hidden: true })
  .nameOverride('content', {
    ordinal: 1000,
    _component: () => BulkMessageInput,
  })
  .nameOverride('addedRecipients', { hidden: true })
  .nameOverride('additionalRecipients', {
    _component: () => Autocomplete,
    _customProps: {
      creatable: true,
      ignoreGroups: true,
      autoSelect: false,
      SelectProps: {
        multiple: true,
      },
      ChipProps: {
        getRootColor: (selectedOption) => {
          let color;
          switch (selectedOption.group) {
            case 'SuperUser':
            case 'LeadPlanner':
            case 'ClientSuccessManager':
            case 'InvestmentOps':
              color = 'accentGreen';
              break;
            case 'Client':
              color = 'accentBlue';
              break;
            default:
              color = 'default'; // <-- Default is gray
          }
          return color;
        },
      },
    },
  })
  .done();
